import { render } from "./ShopConfigureComponent.vue?vue&type=template&id=2be612ce&scoped=true"
import script from "./ShopConfigureComponent.vue?vue&type=script&lang=js"
export * from "./ShopConfigureComponent.vue?vue&type=script&lang=js"

import "./ShopConfigureComponent.vue?vue&type=style&index=0&id=2be612ce&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be612ce"]])

export default __exports__